window.coastalRoomFinderRegistryV2 = {"version":"coastal-room-finder-registry-v2","generatedAt":"2026-09-08T14:51:01.031Z","uniqueProducts":200,"paths":{"quiet":{"seating":{"compact":[{"handle":"greenbriar-loveseat","tier":0,"productId":"15231483707764"},{"handle":"jayne-park-loveseat","tier":0,"productId":"15231505695092"},{"handle":"maitelynn-loveseat-chalk","tier":0,"productId":"15231349719412"},{"handle":"simplejoy-loveseat","tier":0,"productId":"15231340183924"},{"handle":"bridgepoint-loveseat","tier":1,"productId":"15231510413684"},{"handle":"monaghan-loveseat-sandstone","tier":1,"productId":"15231312724340"},{"handle":"aviemore-loveseat","tier":2,"productId":"15231339954548"}],"standard":[{"handle":"greenbriar-sofa","tier":0,"productId":"15231484199284"},{"handle":"greenbriar-sofa-chaise","tier":0,"productId":"15231484232052"},{"handle":"jayne-park-sofa","tier":0,"productId":"15231505924468"},{"handle":"lango-sofa-chaise-jute","tier":0,"productId":"15232315195764"},{"handle":"maitelynn-sofa-chalk","tier":1,"productId":"15231349490036"},{"handle":"monaghan-sofa-sandstone","tier":1,"productId":"15231317836148"},{"handle":"bridgepoint-sofa","tier":2,"productId":"15231510348148"}],"generous":[{"handle":"lango-living-room-set","tier":0,"productId":"15231552455028"},{"handle":"modmax-straight-sectional-oyster","tier":0,"productId":"15255896621428"},{"handle":"aviemore-living-room-set","tier":1,"productId":"15231550587252"},{"handle":"aviemore-sectional-set","tier":1,"productId":"15231550554484"},{"handle":"chessington-sectional","tier":1,"productId":"15231416107380"},{"handle":"edenfield-sectional","tier":1,"productId":"15231391465844"},{"handle":"elyza-sectional","tier":1,"productId":"15231391793524"},{"handle":"lindyn-sectional","tier":1,"productId":"15231393268084"},{"handle":"simplejoy-living-room-set","tier":1,"productId":"15231550325108"},{"handle":"simplejoy-sectional","tier":1,"productId":"15231531876724"},{"handle":"lango-queen-sofa-chaise-sleeper-jute","tier":2,"productId":"15232314474868"},{"handle":"modmax-u-shaped-sectional-oyster","tier":2,"productId":"15255896162676"}]},"accent":[{"handle":"tartonelle-accent-chair","tier":0,"productId":"15231323537780"},{"handle":"valwick-swivel-accent-chair-cream-brown","tier":0,"productId":"15231499862388"},{"handle":"wychworth-accent-chair-gray-natural","tier":0,"productId":"15231453921652"},{"handle":"jayne-park-chair-and-a-half","tier":1,"productId":"15231506055540"},{"handle":"lango-chair-jute","tier":1,"productId":"15232314507636"},{"handle":"monaghan-chair-and-a-half-sandstone","tier":1,"productId":"15231311610228"},{"handle":"padova-swivel-accent-chair-ivory","tier":1,"productId":"15231344017780"},{"handle":"lindyn-oversized-swivel-accent-chair","tier":2,"productId":"15231376327028"},{"handle":"maitelynn-chair-chalk","tier":2,"productId":"15231349621108"},{"handle":"monaghan-living-room-set","tier":2,"productId":"15231537938804"}],"cocktail":[{"handle":"robbinsdale-table","tier":0,"productId":"15231506514292"},{"handle":"burkhaus-rectangular-cocktail-table-white-dark-brown","tier":1,"productId":"15231386026356"},{"handle":"camdill-round-cocktail-table-light-brown-white","tier":1,"productId":"15231421448564"},{"handle":"ella-grove-rectangular-table","tier":1,"productId":"15231509725556"},{"handle":"loyaska-rectangular-cocktail-table-brown-ivory","tier":1,"productId":"15232309363060"},{"handle":"realyn-oval-cocktail-table-white-brown","tier":1,"productId":"15231307678068"},{"handle":"ridgester-lift-top-cocktail-table-light-brown","tier":1,"productId":"15247622734196"},{"handle":"bolanburg-lift-top-cocktail-table-white-brown-beige","tier":2,"productId":"15231314198900"},{"handle":"carynhurst-lift-top-cocktail-table-white-wash-gray","tier":2,"productId":"15231313248628"},{"handle":"montia-square-cocktail-table-multi","tier":2,"productId":"15231404867956"}],"side":[{"handle":"bolanburg-chair-side-end-table","tier":0,"productId":"15231321112948"},{"handle":"camdill-round-end-table-light-brown-white","tier":0,"productId":"15231422038388"},{"handle":"carynhurst-rectangular-end-table-white-wash-gray","tier":0,"productId":"15232306348404"},{"handle":"fendenmore-chair-side-end-table","tier":0,"productId":"15231484658036"},{"handle":"fostead-square-end-table-white-espresso","tier":0,"productId":"15231385207156"},{"handle":"ridgester-round-table","tier":0,"productId":"15231509594484"},{"handle":"wystfield-chair-side-end-table-white-brown","tier":0,"productId":"15231308988788"},{"handle":"wystfield-rectangular-end-table-2-doors-white-brown","tier":0,"productId":"15231313019252"},{"handle":"realyn-round-end-table-white-brown","tier":1,"productId":"15231312953716"},{"handle":"montia-square-end-table-multi","tier":2,"productId":"15231404900724"}]},"warm":{"seating":{"compact":[{"handle":"chasemore-loveseat","tier":0,"productId":"15231437046132"},{"handle":"navi-loveseat-fossil","tier":0,"productId":"15231330845044"},{"handle":"roxmere-loveseat-umber","tier":0,"productId":"15231431377268"},{"handle":"telora-loveseat-caramel","tier":0,"productId":"15231342182772"},{"handle":"villacourt-loveseat-caramel","tier":0,"productId":"15231476597108"},{"handle":"carianna-loveseat-caramel","tier":1,"productId":"15231348769140"},{"handle":"colleton-loveseat-dark-brown","tier":1,"productId":"15231331664244"},{"handle":"stoneland-power-reclining-loveseat","tier":1,"productId":"15231373017460"}],"standard":[{"handle":"chasemore-sofa","tier":0,"productId":"15231436489076"},{"handle":"navi-sofa-fossil","tier":0,"productId":"15231330877812"},{"handle":"roxmere-sofa-umber","tier":0,"productId":"15231469781364"},{"handle":"telora-sofa-caramel","tier":0,"productId":"15231387140468"},{"handle":"villacourt-sofa-caramel","tier":0,"productId":"15231455101300"},{"handle":"boothbay-2-seat-reclining-sofa","tier":1,"productId":"15231395103092"},{"handle":"carianna-sofa-caramel","tier":1,"productId":"15231348834676"},{"handle":"chasemore-sofa-sleeper","tier":1,"productId":"15231436620148"},{"handle":"colleton-sofa-dark-brown","tier":1,"productId":"15231329436020"},{"handle":"navi-queen-sofa-sleeper-fossil","tier":1,"productId":"15231330943348"},{"handle":"roxmere-queen-sofa-sleeper-umber","tier":1,"productId":"15231472435572"},{"handle":"stoneland-power-reclining-sofa","tier":1,"productId":"15231373181300"},{"handle":"stoneland-reclining-sofa","tier":1,"productId":"15231373312372"},{"handle":"willowbend-sofa","tier":1,"productId":"15231482921332"},{"handle":"carianna-queen-sofa-sleeper-caramel","tier":2,"productId":"15231347851636"}],"generous":[{"handle":"bridgepoint-sectional","tier":0,"productId":"15231532695924"},{"handle":"willowbend-sectional","tier":1,"productId":"15231529779572"},{"handle":"bolsena-living-room-set","tier":2,"productId":"15231545147764"},{"handle":"deepwakes-power-reclining-sectional","tier":2,"productId":"15231525585268"},{"handle":"donelson-creek-sectional","tier":2,"productId":"15232315720052"},{"handle":"emilia-3-pc-2-piece-sectional-loveseat-ottoman-caramel","tier":2,"productId":"15231537119604"},{"handle":"emilia-sectional","tier":2,"productId":"15231357518196"},{"handle":"magic-man-reclining-sectional","tier":2,"productId":"15231465062772"},{"handle":"stoneland-power-reclining-living-room-set","tier":2,"productId":"15231535513972"},{"handle":"stoneland-reclining-living-room-set","tier":2,"productId":"15231535645044"}]},"accent":[{"handle":"bradney-swivel-accent-chair","tier":0,"productId":"15231389106548"},{"handle":"goda-accent-chair","tier":0,"productId":"15231511134580"},{"handle":"bridgepoint-chair-moss","tier":1,"productId":"15231499501940"},{"handle":"chasemore-swivel-glider-recliner","tier":1,"productId":"15231438979444"},{"handle":"kierreys-swivel-chair","tier":1,"productId":"15231412568436"},{"handle":"mcgann-rocker-recliner","tier":1,"productId":"15231323144564"},{"handle":"roxmere-chair-umber","tier":1,"productId":"15231469814132"},{"handle":"roxmere-living-room-set","tier":1,"productId":"15231552094580"},{"handle":"telora-chair-caramel","tier":1,"productId":"15231387173236"},{"handle":"telora-living-room-set","tier":1,"productId":"15231544492404"},{"handle":"villacourt-chair-and-a-half-caramel","tier":1,"productId":"15231455789428"},{"handle":"wardington-accent-chair-multi-beige","tier":1,"productId":"15231521784180"},{"handle":"carianna-chair-and-a-half-caramel","tier":2,"productId":"15231348703604"},{"handle":"carianna-living-room-set","tier":2,"productId":"15231545246068"},{"handle":"garronmont-accent-chair-caramel","tier":2,"productId":"15231443435892"}],"cocktail":[{"handle":"brendalhouse-rectangular-table","tier":0,"productId":"15231440421236"},{"handle":"kandinew-living-room-table","tier":0,"productId":"15231510446452"},{"handle":"breckington-rectangle-cocktail-table-dark-brown","tier":1,"productId":"15275005575540"},{"handle":"burkbyer-rectangular-table","tier":1,"productId":"15231462408564"},{"handle":"dreggan-rectangular-cocktail-table-brown","tier":1,"productId":"15231399166324"},{"handle":"frallyn-round-cocktail-table-dark-brown","tier":1,"productId":"15231471157620"},{"handle":"valebeck-lift-top-cocktail-table-black-brown","tier":1,"productId":"15231317999988"},{"handle":"dressonni-rectangular-cocktail-table-brown","tier":2,"productId":"15231333106036"},{"handle":"hannodream-square-cocktail-table-warm-brown","tier":2,"productId":"15231399756148"},{"handle":"tyler-creek-lift-top-cocktail-table-grayish-brown-black","tier":2,"productId":"15231308300660"}],"side":[{"handle":"carlibrie-rectangular-table","tier":0,"productId":"15231487541620"},{"handle":"dontayne-round-table","tier":0,"productId":"15231509430644"},{"handle":"flangren-round-end-table-light-brown","tier":0,"productId":"15231502582132"},{"handle":"frallyn-round-end-table-dark-brown","tier":0,"productId":"15231429542260"},{"handle":"noraluna-round-table","tier":0,"productId":"15231513166196"},{"handle":"rosswain-square-end-table-warm-brown","tier":0,"productId":"15231353487732"},{"handle":"brinstead-chair-side-end-table-light-brown","tier":1,"productId":"15231332319604"},{"handle":"dreggan-square-end-table-brown","tier":1,"productId":"15231399133556"},{"handle":"hannodream-square-end-table-warm-brown","tier":1,"productId":"15231399625076"},{"handle":"jorielyn-square-table","tier":2,"productId":"15231487508852"}]},"casual":{"seating":{"compact":[{"handle":"foreside-dbl-reclining-loveseat-with-console-charcoal","tier":0,"productId":"15231333663092"},{"handle":"orlen-double-reclining-loveseat-with-console-winter","tier":0,"productId":"15231491473780"},{"handle":"simplejoy-sofa","tier":0,"productId":"15231413649780"},{"handle":"biscoe-power-reclining-loveseat-with-console-adj-headrest-pewter","tier":1,"productId":"15231355584884"},{"handle":"studio-cave-power-reclining-loveseat-with-console-steel","tier":1,"productId":"15231404310900"},{"handle":"5z-comfort-relaxation-power-reclining-loveseat-with-console-adj-headrest","tier":2,"productId":"15231483183476"},{"handle":"aviemore-sofa","tier":2,"productId":"15231411454324"},{"handle":"next-gen-durapella-power-reclining-loveseat","tier":2,"productId":"15231389958516"},{"handle":"next-gen-durapella-reclining-power-loveseat-with-console","tier":2,"productId":"15231372689780"}],"standard":[{"handle":"foreside-reclining-sofa-charcoal","tier":0,"productId":"15231405687156"},{"handle":"hartside-sofa-frosted","tier":0,"productId":"15231501762932"},{"handle":"biscoe-power-reclining-sofa-with-adj-headrest-pewter","tier":1,"productId":"15231355486580"},{"handle":"studio-cave-power-reclining-sofa-steel","tier":1,"productId":"15231333073268"},{"handle":"tallow-creek-sofa-shadow","tier":1,"productId":"15231524372852"},{"handle":"5z-comfort-relaxation-power-reclining-sofa-with-adj-headrest","tier":2,"productId":"15231483347316"},{"handle":"next-gen-durapella-power-reclining-sofa","tier":2,"productId":"15231389892980"},{"handle":"next-gen-durapella-reclining-power-sofa","tier":2,"productId":"15231374197108"}],"generous":[{"handle":"bales-sectional","tier":0,"productId":"15231395299700"},{"handle":"modmax-straight-sectional-granite","tier":0,"productId":"15255896752500"},{"handle":"modmax-straight-sectional-ink","tier":0,"productId":"15255896785268"},{"handle":"modmax-straight-sectional-spice","tier":0,"productId":"15255896850804"},{"handle":"acklen-place-reclining-sectional","tier":1,"productId":"15231417581940"},{"handle":"alphons-living-room-set","tier":1,"productId":"15231542526324"},{"handle":"bealton-sectional","tier":1,"productId":"15231530566004"},{"handle":"darcy-living-room-set","tier":1,"productId":"15231535907188"},{"handle":"east-loft-power-reclining-sectional","tier":1,"productId":"15231533810036"},{"handle":"frohn-reclining-living-room-set","tier":1,"productId":"15231551046004"},{"handle":"lentiz-sectional","tier":1,"productId":"15231531811188"},{"handle":"modmax-ii-reclining-sectional-salt-and-pepper","tier":1,"productId":"15231526863220"},{"handle":"modmax-ii-reclining-sectional-stone","tier":1,"productId":"15231526895988"},{"handle":"next-gen-durapella-reclining-sectional","tier":1,"productId":"15231416041844"},{"handle":"social-pointe-reclining-sectional","tier":1,"productId":"15231528796532"},{"handle":"urbancrest-sleeper-sectional","tier":1,"productId":"15231532532084"},{"handle":"acklen-place-4-pc-3-piece-power-reclining-sectional-sofa-with-raf-chaise-wide-seat-power-recliner-pewter","tier":2,"productId":"15231546622324"},{"handle":"correze-power-reclining-sectional","tier":2,"productId":"15231392121204"},{"handle":"koralynn-sectional","tier":2,"productId":"15231417680244"},{"handle":"modmax-u-shaped-sectional-ink","tier":2,"productId":"15255896195444"},{"handle":"modmax-u-shaped-sectional-spice","tier":2,"productId":"15255896260980"},{"handle":"next-gen-durapella-power-reclining-living-room-set","tier":2,"productId":"15231535546740"},{"handle":"next-gen-durapella-power-reclining-sectional-set","tier":2,"productId":"15231548948852"},{"handle":"pearce-pike-reclining-sectional","tier":2,"productId":"15231531549044"}]},"accent":[{"handle":"bixler-showood-accent-chair","tier":0,"productId":"15231338905972"},{"handle":"simplejoy-rocker-recliner","tier":0,"productId":"15231340544372"},{"handle":"acklen-place-wide-seat-power-recliner-pewter","tier":1,"productId":"15231407063412"},{"handle":"alainmont-next-gen-nuvella-swivel-power-recliner","tier":1,"productId":"15231483281780"},{"handle":"biscoe-power-recliner-adj-headrest-pewter","tier":1,"productId":"15231355552116"},{"handle":"foreside-rocker-recliner-charcoal","tier":1,"productId":"15231405425012"},{"handle":"modmax-swivel-glider-recliner","tier":1,"productId":"15231358435700"},{"handle":"morrilton-next-gen-nuvella-accent-chair-natural-charcoal","tier":1,"productId":"15231331303796"},{"handle":"rowenburg-swivel-glider-accent-chair","tier":1,"productId":"15231511462260"},{"handle":"skillins-rocker-recliner-stone","tier":1,"productId":"15231333171572"},{"handle":"modmax-luxe-swivel-glider-power-recliner-flint","tier":2,"productId":"15231499633012"},{"handle":"next-gen-durapella-power-recliner","tier":2,"productId":"15231374459252"},{"handle":"pineland-glider-power-recliner-with-audio-system-pewter","tier":2,"productId":"15231447499124"},{"handle":"studio-cave-power-recliner-steel","tier":2,"productId":"15231404376436"},{"handle":"tallow-creek-chair-and-a-half-shadow","tier":2,"productId":"15231518835060"}],"cocktail":[{"handle":"baretton-accent-cocktail-table","tier":0,"productId":"15231481872756"},{"handle":"watson-rectangular-cocktail-table-dark-brown","tier":0,"productId":"15232306446708"},{"handle":"breckington-cocktail-table-with-storage-dark-brown","tier":1,"productId":"15231477612916"},{"handle":"dalenville-rectangular-cocktail-table-gray","tier":1,"productId":"15231371182452"},{"handle":"darborn-lift-top-cocktail-table-gray-brown","tier":1,"productId":"15231332417908"},{"handle":"rylandyn-lift-top-cocktail-table-black-light-brown","tier":1,"productId":"15231492391284"},{"handle":"wildenauer-lift-top-cocktail-table-brown-black","tier":1,"productId":"15231448187252"},{"handle":"kallenny-square-cocktail-table-brown-gray","tier":2,"productId":"15231447662964"},{"handle":"todoe-lift-top-cocktail-table-dark-gray","tier":2,"productId":"15231310594420"},{"handle":"torlanta-lift-top-cocktail-table-brown","tier":2,"productId":"15231403032948"}],"side":[{"handle":"camdill-chair-side-end-table","tier":0,"productId":"15231484526964"},{"handle":"frazwa-round-end-table-multi","tier":0,"productId":"15231351095668"},{"handle":"gardoni-chair-side-end-table-white-black","tier":0,"productId":"15231324389748"},{"handle":"gardoni-rectangular-end-table-white-black","tier":0,"productId":"15231353717108"},{"handle":"rylandyn-rectangular-end-table-black-light-brown","tier":0,"productId":"15231492456820"},{"handle":"surmour-triangle-end-table-gray-brown","tier":0,"productId":"15231420989812"},{"handle":"torlanta-chair-side-end-table-brown","tier":0,"productId":"15231397790068"},{"handle":"watson-square-end-table-dark-brown","tier":0,"productId":"15232307200372"},{"handle":"breckington-rectangular-2-door-end-table-dark-brown","tier":1,"productId":"15231456084340"},{"handle":"roanhowe-rectangular-end-table-brown","tier":2,"productId":"15231354896756"}]}}};

/* coastal-room-finder-v1 */
(() => {
if (window.coastalRoomFinderV1) return;
window.coastalRoomFinderV1 = true;

const finderUrl = '/pages/design-help?finder=living-room';
const consultationUrl = '/pages/contact?topic=design-help&from=room-finder';
const resultStorageKey = 'coastal-room-finder-result-v1';
const savedPlanStorageKey = 'coastal-room-finder-saved-plan-v1';
const rotationStorageKey = 'coastal-room-finder-rotation-v1';

const choices = {
space: {
compact: { label: 'Compact', copy: 'Apartment, den or a room under roughly 12 × 12 ft.' },
standard: { label: 'Standard', copy: 'A typical living room with room for a sofa and accent seating.' },
generous: { label: 'Generous', copy: 'An open or larger room with space for sectional seating.' },
},
style: {
quiet: { label: 'Quiet Coastal', copy: 'Airy neutrals, pale finishes and an easy, collected feeling.' },
warm: { label: 'Warm Natural', copy: 'Layered woods, grounded color and relaxed texture.' },
casual: { label: 'Casual Contemporary', copy: 'Clean silhouettes, comfortable upholstery and practical pieces.' },
},
household: {
everyday: { label: 'Everyday living', copy: 'A comfortable room for reading, relaxing and daily use.', guidance: 'Favor easy circulation and leave comfortable reach between seating and tables.' },
family: { label: 'Family & pets', copy: 'Durability, easy living and generous comfort come first.', guidance: 'Confirm upholstery care, performance-fabric details and clear walking paths before ordering.' },
entertaining: { label: 'Entertaining', copy: 'Conversation-friendly seating and flexible surfaces.', guidance: 'Arrange seating for conversation and preserve flexible surfaces for drinks, lighting and serving.' },
rental: { label: 'Vacation rental', copy: 'Welcoming, versatile pieces selected for broad appeal.', guidance: 'Prioritize straightforward care, flexible placement and pieces that are easy for guests to understand.' },
},
budget: {
essential: { label: 'Up to $2,500', copy: 'Start with four foundational pieces and add layers over time.', index: 0 },
considered: { label: '$2,500–$5,000 room budget', copy: 'Balance the four starting pieces with room for lighting, rugs and accents.', index: 1 },
elevated: { label: '$5,000+ room budget', copy: 'Use elevated room-building options while keeping the first recommendation focused.', index: 2 },
},
timing: {
browsing: { label: 'Just exploring', copy: 'Save a direction and return when the timing is right.', guidance: 'Save this direction, compare dimensions and revisit availability when you are closer to ordering.' },
season: { label: 'Within 1–3 months', copy: 'Start narrowing pieces and confirming measurements.', guidance: 'Confirm room and access measurements now, then recheck price and availability before ordering.' },
soon: { label: 'As soon as possible', copy: 'Prioritize pieces that are available when you review them.', guidance: 'These pieces are available now; confirm measurements and current delivery timing before checkout.' },
},
};

const steps = [
{ key: 'space', eyebrow: 'Your space', title: 'How much room are we working with?' },
{ key: 'style', eyebrow: 'Your direction', title: 'Which room feels most like you?' },
{ key: 'household', eyebrow: 'How you live', title: 'What does this room need to handle?' },
{ key: 'budget', eyebrow: 'Your investment', title: 'What furniture budget should guide the plan?' },
{ key: 'timing', eyebrow: 'Your timing', title: 'When would you like the room to come together?' },
];

const plans = {
quiet: {
title: 'Quiet Coastal Living Room',
eyebrow: 'Light, calm and comfortably collected',
copy: 'A soft neutral foundation with natural texture and restrained contrast—coastal without feeling themed.',
searchUrl: '/collections/living-room',
products: {
seating: {
compact: ['maitelynn-loveseat-chalk', 'bridgepoint-loveseat', 'aviemore-loveseat'],
standard: ['lango-sofa-chaise-jute', 'maitelynn-sofa-chalk', 'bridgepoint-sofa'],
generous: ['lango-living-room-set', 'aviemore-sectional-set', 'lango-queen-sofa-chaise-sleeper-jute'],
},
accent: ['wychworth-accent-chair-gray-natural', 'lango-chair-jute', 'maitelynn-chair-chalk'],
cocktail: ['robbinsdale-table', 'realyn-oval-cocktail-table-white-brown', 'montia-square-cocktail-table-multi'],
side: ['camdill-round-end-table-light-brown-white', 'realyn-round-end-table-white-brown', 'montia-square-end-table-multi'],
},
},
warm: {
title: 'Warm Natural Living Room',
eyebrow: 'Grounded woods and relaxed texture',
copy: 'An inviting room built around warm finishes, comfortable seating and pieces that feel collected over time.',
searchUrl: '/collections/living-room',
products: {
seating: {
compact: ['bridgepoint-loveseat', 'aviemore-loveseat', 'maitelynn-loveseat-chalk'],
standard: ['bridgepoint-sofa', 'willowbend-sofa', 'lango-sofa-chaise-jute'],
generous: ['bridgepoint-sectional', 'willowbend-sectional', 'donelson-creek-sectional'],
},
accent: ['goda-accent-chair', 'bridgepoint-chair-moss', 'garronmont-accent-chair-caramel'],
cocktail: ['brendalhouse-rectangular-table', 'breckington-rectangle-cocktail-table-dark-brown', 'dressonni-rectangular-cocktail-table-brown'],
side: ['noraluna-round-table', 'brinstead-chair-side-end-table-light-brown', 'jorielyn-square-table'],
},
},
casual: {
title: 'Casual Contemporary Living Room',
eyebrow: 'Clean, comfortable and ready for real life',
copy: 'A practical, flexible room with approachable silhouettes and a balance of comfort, storage and easy movement.',
searchUrl: '/collections/living-room',
products: {
seating: {
compact: ['simplejoy-sofa', 'bridgepoint-loveseat', 'aviemore-sofa'],
standard: ['hartside-sofa-frosted', 'tallow-creek-sofa-shadow', 'lango-sofa-chaise-jute'],
generous: ['bales-sectional', 'bealton-sectional', 'donelson-creek-sectional'],
},
accent: ['bixler-showood-accent-chair', 'morrilton-next-gen-nuvella-accent-chair-natural-charcoal', 'tallow-creek-chair-and-a-half-shadow'],
cocktail: ['breckington-rectangle-cocktail-table-dark-brown', 'breckington-cocktail-table-with-storage-dark-brown', 'torlanta-lift-top-cocktail-table-brown'],
side: ['watson-square-end-table-dark-brown', 'breckington-rectangular-2-door-end-table-dark-brown', 'roanhowe-rectangular-end-table-brown'],
},
},
};

const roleLabels = {
seating: 'Seating anchor',
accent: 'Accent chair',
cocktail: 'Coffee table',
side: 'End table',
};

const ensureStyles = () => {
if (document.getElementById('coastal-room-finder-v1-styles')) return;
const style = document.createElement('style');
style.id = 'coastal-room-finder-v1-styles';
style.textContent = `
.coastal-room-finder-launch {
display: grid;
grid-template-columns: minmax(0, 1fr);
gap: clamp(1.5rem, 4vw, 4rem);
align-items: center;
margin: clamp(2rem, 5vw, 4rem) 0;
padding: clamp(1.5rem, 5vw, 4.5rem);
background: #e9e2d8;
color: #272522;
overflow-wrap: normal;
word-break: normal;
}
.coastal-room-finder-launch__eyebrow,
.coastal-room-finder__eyebrow,
.coastal-room-finder-result__eyebrow {
margin: 0 0 .65rem;
font-size: .72rem;
font-weight: 700;
letter-spacing: .14em;
text-transform: uppercase;
}
.coastal-room-finder-launch h2 {
max-width: none;
margin: 0;
font-family: var(--heading-font-family);
font-size: clamp(2rem, 3.25vw, 3.25rem);
font-weight: 400;
line-height: 1.03;
letter-spacing: -.035em;
overflow-wrap: normal;
word-break: normal;
hyphens: none;
}
.coastal-room-finder-launch__copy {
max-width: 42rem;
margin: 1rem 0 0;
line-height: 1.7;
}
.coastal-room-finder-launch__aside {
min-width: 0;
padding-top: 1.25rem;
padding-left: 0;
border-top: 1px solid rgba(39, 37, 34, .18);
border-left: 0;
}
.coastal-room-finder-launch__aside p {
margin: 0;
line-height: 1.65;
}
.coastal-room-finder__button,
.coastal-room-finder__link-button {
display: inline-flex;
align-items: center;
justify-content: center;
min-height: 48px;
padding: .85rem 1.25rem;
border: 1px solid #272522;
border-radius: 0;
background: #272522 !important;
background-image: none !important;
color: #fff !important;
font: inherit;
font-size: .9rem;
font-weight: 650;
line-height: 1.2;
text-decoration: none;
cursor: pointer;
}
.coastal-room-finder__link-button::before,
.coastal-room-finder__link-button::after {
display: none !important;
content: none !important;
}
.coastal-room-finder__button--secondary,
.coastal-room-finder__link-button--secondary {
background: transparent !important;
color: #272522 !important;
}
.coastal-room-finder__button:hover,
.coastal-room-finder__button:focus-visible,
.coastal-room-finder__link-button:hover,
.coastal-room-finder__link-button:focus-visible {
opacity: .74;
}
.coastal-room-finder-launch .coastal-room-finder__link-button {
margin-top: 1.25rem;
}
.coastal-room-finder {
max-width: 1180px;
margin: clamp(1.5rem, 4vw, 3rem) auto clamp(3rem, 7vw, 6rem);
padding-inline: max(1.25rem, 4vw);
color: #272522;
}
.coastal-room-finder__header {
display: flex;
justify-content: space-between;
gap: 1.25rem;
align-items: flex-end;
margin-bottom: clamp(1.5rem, 4vw, 3rem);
}
.coastal-room-finder__header h1 {
max-width: 15ch;
margin: 0;
font-family: var(--heading-font-family);
font-size: clamp(2.35rem, 5.5vw, 5rem);
font-weight: 400;
line-height: .98;
letter-spacing: -.045em;
}
.coastal-room-finder__intro {
max-width: 38rem;
margin: .9rem 0 0;
line-height: 1.7;
}
.coastal-room-finder__progress-wrap {
min-width: min(18rem, 35vw);
}
.coastal-room-finder__progress-label {
display: flex;
justify-content: space-between;
gap: 1rem;
margin-bottom: .5rem;
font-size: .78rem;
font-weight: 650;
}
.coastal-room-finder__progress {
height: 3px;
overflow: hidden;
background: rgba(39, 37, 34, .15);
}
.coastal-room-finder__progress span {
display: block;
height: 100%;
background: #272522;
transition: width .25s ease;
}
.coastal-room-finder__stage {
padding: clamp(1.5rem, 5vw, 4rem);
background: #f2eee7;
}
.coastal-room-finder__stage h2 {
max-width: 20ch;
margin: 0 0 clamp(1.5rem, 3vw, 2.5rem);
font-family: var(--heading-font-family);
font-size: clamp(1.9rem, 4vw, 3.25rem);
font-weight: 400;
line-height: 1.05;
letter-spacing: -.03em;
}
.coastal-room-finder__options {
display: grid;
grid-template-columns: repeat(3, minmax(0, 1fr));
gap: 1rem;
margin: 0;
padding: 0;
border: 0;
}
.coastal-room-finder__option {
position: relative;
display: block;
min-height: 9.5rem;
padding: 1.25rem;
border: 1px solid rgba(39, 37, 34, .2);
background: rgba(255, 255, 255, .5);
cursor: pointer;
}
.coastal-room-finder__option:has(input:checked) {
border-color: #272522;
background: #fff;
box-shadow: inset 0 0 0 1px #272522;
}
.coastal-room-finder__option input {
position: absolute;
top: 1rem;
right: 1rem;
width: 1.1rem;
height: 1.1rem;
accent-color: #272522;
}
.coastal-room-finder__option strong {
display: block;
max-width: calc(100% - 2rem);
margin-bottom: .5rem;
font-size: 1.03rem;
}
.coastal-room-finder__option span {
display: block;
font-size: .88rem;
line-height: 1.55;
opacity: .78;
}
.coastal-room-finder__actions {
display: flex;
justify-content: space-between;
gap: .75rem;
margin-top: 1.5rem;
}
.coastal-room-finder__actions-group {
display: flex;
gap: .75rem;
}
.coastal-room-finder__error {
margin: 1rem 0 0;
color: #8a2d21;
font-size: .88rem;
}
.coastal-room-finder-result {
display: grid;
gap: clamp(1.5rem, 4vw, 3rem);
}
.coastal-room-finder-result__heading {
display: grid;
grid-template-columns: minmax(0, 1.25fr) minmax(17rem, .75fr);
gap: clamp(1.5rem, 5vw, 5rem);
align-items: end;
}
.coastal-room-finder-result__heading h2 {
max-width: 17ch;
margin: 0;
}
.coastal-room-finder-result__heading-copy {
margin: 0;
line-height: 1.7;
}
.coastal-room-finder-result__summary {
display: flex;
flex-wrap: wrap;
gap: .5rem 1rem;
margin: 0;
padding: .9rem 0;
border-block: 1px solid rgba(39, 37, 34, .16);
list-style: none;
font-size: .8rem;
}
.coastal-room-finder-result__summary strong {
margin-right: .3rem;
}
.coastal-room-finder-result__guidance {
display: grid;
grid-template-columns: repeat(2, minmax(0, 1fr));
gap: 1rem;
}
.coastal-room-finder-result__guidance p {
margin: 0;
padding: 1rem 1.1rem;
background: rgba(222, 211, 196, .48);
font-size: .86rem;
line-height: 1.55;
}
.coastal-room-finder-result__guidance strong {
display: block;
margin-bottom: .25rem;
font-size: .7rem;
letter-spacing: .1em;
text-transform: uppercase;
}
.coastal-room-finder-result__products {
display: grid;
grid-template-columns: repeat(4, minmax(0, 1fr));
gap: 1rem;
}
.coastal-room-finder-product {
min-width: 0;
}
.coastal-room-finder-product__media {
display: block;
aspect-ratio: 1 / 1;
overflow: hidden;
background: #fff;
}
.coastal-room-finder-product__media img {
display: block;
width: 100%;
height: 100%;
object-fit: contain;
transition: transform .25s ease;
}
.coastal-room-finder-product__media:hover img {
transform: scale(1.02);
}
.coastal-room-finder-product__role {
margin: .85rem 0 .25rem;
font-size: .68rem;
font-weight: 700;
letter-spacing: .11em;
text-transform: uppercase;
opacity: .68;
}
.coastal-room-finder-product h3 {
margin: 0;
font-size: .95rem;
line-height: 1.35;
}
.coastal-room-finder-product h3 a {
color: inherit;
text-decoration: none;
}
.coastal-room-finder-product__price {
margin: .35rem 0 0;
font-size: .88rem;
}
.coastal-room-finder-result__total {
display: flex;
justify-content: space-between;
gap: 1.5rem;
align-items: flex-start;
padding: 1.25rem 0;
border-top: 1px solid rgba(39, 37, 34, .16);
}
.coastal-room-finder-result__total p {
max-width: 42rem;
margin: 0;
font-size: .84rem;
line-height: 1.55;
opacity: .75;
}
.coastal-room-finder-result__total strong {
white-space: nowrap;
font-size: 1.1rem;
}
.coastal-room-finder-fit {
padding: clamp(1.25rem, 3vw, 2rem);
border: 1px solid rgba(39, 37, 34, .18);
background: rgba(255, 255, 255, .48);
}
.coastal-room-finder-fit__heading {
display: flex;
justify-content: space-between;
gap: 1.5rem;
align-items: center;
}
.coastal-room-finder-fit__heading h3 {
margin: 0 0 .35rem;
font-family: var(--heading-font-family);
font-size: clamp(1.45rem, 2.5vw, 2rem);
font-weight: 400;
}
.coastal-room-finder-fit__heading p,
.coastal-room-finder-fit__note {
margin: 0;
font-size: .86rem;
line-height: 1.55;
opacity: .78;
}
.coastal-room-finder-fit__form {
display: grid;
grid-template-columns: repeat(2, minmax(0, 1fr));
gap: 1rem;
margin-top: 1.5rem;
}
.coastal-room-finder-fit__field {
display: grid;
gap: .4rem;
min-width: 0;
}
.coastal-room-finder-fit__field label,
.coastal-room-finder-fit__field legend {
font-size: .76rem;
font-weight: 700;
letter-spacing: .04em;
}
.coastal-room-finder-fit__field input,
.coastal-room-finder-fit__field select {
width: 100%;
min-height: 48px;
padding: .7rem .8rem;
border: 1px solid rgba(39, 37, 34, .35);
border-radius: 0;
background: #fff;
color: #272522;
font: inherit;
}
.coastal-room-finder-fit__field--wide,
.coastal-room-finder-fit__actions,
.coastal-room-finder-fit__assessment {
grid-column: 1 / -1;
}
.coastal-room-finder-fit__actions {
display: flex;
justify-content: flex-end;
}
.coastal-room-finder-fit__assessment {
padding: 1rem 1.1rem;
background: #e9e2d8;
}
.coastal-room-finder-fit__assessment h4 {
margin: 0 0 .5rem;
font-size: 1rem;
}
.coastal-room-finder-fit__assessment ul {
margin: 0;
padding-left: 1.1rem;
font-size: .86rem;
line-height: 1.55;
}
.coastal-room-finder-result__consult {
display: grid;
grid-template-columns: minmax(0, 1fr) auto;
gap: 1.5rem;
align-items: center;
padding: clamp(1.5rem, 4vw, 3rem);
background: #ded3c4;
}
.coastal-room-finder-result__consult h3 {
margin: 0 0 .4rem;
font-family: var(--heading-font-family);
font-size: clamp(1.5rem, 3vw, 2.2rem);
font-weight: 400;
}
.coastal-room-finder-result__consult p {
max-width: 42rem;
margin: 0;
line-height: 1.6;
}
.coastal-room-finder__loading {
padding: clamp(3rem, 8vw, 7rem) 1rem;
text-align: center;
}
.coastal-room-finder__loading p {
margin: .75rem 0 0;
}
@media (max-width: 1399px) {
.coastal-room-finder-launch,
.coastal-room-finder-result__heading {
grid-template-columns: 1fr;
}
.coastal-room-finder-launch__aside {
padding-top: 1.25rem;
padding-left: 0;
border-top: 1px solid rgba(39, 37, 34, .18);
border-left: 0;
}
.coastal-room-finder__header {
display: grid;
}
.coastal-room-finder__progress-wrap {
min-width: 0;
}
.coastal-room-finder-result__products {
grid-template-columns: repeat(2, minmax(0, 1fr));
}
.coastal-room-finder-result__guidance {
grid-template-columns: 1fr;
}
}
@media (max-width: 699px) {
.coastal-room-finder {
margin-top: 1rem;
padding-inline: 1rem;
}
.coastal-room-finder__stage {
padding: 1.25rem;
}
.coastal-room-finder__options {
grid-template-columns: 1fr;
}
.coastal-room-finder__option {
min-height: 0;
padding: 1rem 2.75rem 1rem 1rem;
}
.coastal-room-finder__actions,
.coastal-room-finder__actions-group,
.coastal-room-finder-result__consult,
.coastal-room-finder-fit__heading,
.coastal-room-finder-fit__form {
display: grid;
grid-template-columns: 1fr;
}
.coastal-room-finder-fit__field--wide,
.coastal-room-finder-fit__actions,
.coastal-room-finder-fit__assessment {
grid-column: auto;
}
.coastal-room-finder__actions-group {
width: 100%;
}
.coastal-room-finder__button,
.coastal-room-finder__link-button {
width: 100%;
}
.coastal-room-finder-result__products {
gap: 1.25rem .75rem;
}
.coastal-room-finder-result__total {
display: grid;
}
}
@media (prefers-reduced-motion: reduce) {
.coastal-room-finder__progress span,
.coastal-room-finder-product__media img {
transition: none;
}
}
`;
document.head.appendChild(style);
};

const emitEvent = (event, detail = {}) => {
const payload = { event, pathway: 'coastal-room-finder', page_path: window.location.pathname, ...detail };
document.dispatchEvent(new CustomEvent('coastal:room-finder', { detail: payload }));
if (Array.isArray(window.dataLayer)) window.dataLayer.push(payload);
};

const safeStorage = {
get(storage, key) {
try { return storage.getItem(key); } catch { return null; }
},
set(storage, key, value) {
try { storage.setItem(key, value); return true; } catch { return false; }
},
};

const mountLaunchCard = () => {
if (window.location.pathname !== '/pages/design-help') return;
const params = new URLSearchParams(window.location.search);
if (params.get('finder') === 'living-room') return;
const main = document.querySelector('main');
if (!main || main.querySelector('[data-coastal-room-finder-launch]')) return;
const pathwaySteps = main.querySelector('[data-coastal-design-pathway="steps"]');
const anchor = pathwaySteps || main.querySelector('[data-coastal-design-pathway="intro"]');
if (!anchor) return;
const section = document.createElement('section');
section.className = 'coastal-room-finder-launch';
section.dataset.coastalRoomFinderLaunch = 'living-room';
section.setAttribute('aria-labelledby', 'coastal-room-finder-launch-title');
section.innerHTML = `
<div>
<p class="coastal-room-finder-launch__eyebrow">New · Living Room Finder</p>
<h2 id="coastal-room-finder-launch-title">Find a room direction before you browse.</h2>
<p class="coastal-room-finder-launch__copy">Answer five quick questions and receive a coordinated living-room starting point built from current Coastal products.</p>
</div>
<div class="coastal-room-finder-launch__aside">
<p>No account required. Your answers stay on this device unless you choose to send the plan to a Coastal designer.</p>
<a class="coastal-room-finder__link-button" href="${finderUrl}">Find my living room</a>
</div>
`;
anchor.insertAdjacentElement('afterend', section);
};

const normalizeProduct = (product, role) => {
const variants = Array.isArray(product.variants) ? product.variants : [];
const availableVariants = variants.filter((variant) => variant.available);
if (!product.available || !availableVariants.length) return null;
const chosenVariant = availableVariants.reduce((best, variant) => {
if (!best) return variant;
return Number(variant.price) < Number(best.price) ? variant : best;
}, null);
const rawImage = product.featured_image || product.images?.[0];
const image = typeof rawImage === 'string' ? rawImage : rawImage?.src;
return {
role,
handle: product.handle,
title: product.title,
image,
price: Number(chosenVariant?.price ?? product.price ?? 0),
variantId: chosenVariant?.id || null,
url: `/products/${encodeURIComponent(product.handle)}`,
};
};

const fetchProduct = async (handle, role) => {
try {
const response = await fetch(`/products/${encodeURIComponent(handle)}.js`, { credentials: 'same-origin' });
if (!response.ok) return null;
return normalizeProduct(await response.json(), role);
} catch {
return null;
}
};

const nextRotation = (answers) => {
const path = [answers.style, answers.space, answers.budget].join(':');
let rotations = {};
try { rotations = JSON.parse(safeStorage.get(localStorage, rotationStorageKey) || '{}'); } catch { rotations = {}; }
const current = Number(rotations[path] || 0);
rotations[path] = current + 1;
safeStorage.set(localStorage, rotationStorageKey, JSON.stringify(rotations));
return current;
};

const orderedCandidates = (candidates, preferredIndex, rotation) => {
const normalized = candidates.map((candidate, index) => typeof candidate === 'string'
? { handle: candidate, tier: index }
: candidate);
const groups = [0, 1, 2]
.sort((a, b) => Math.abs(a - preferredIndex) - Math.abs(b - preferredIndex))
.flatMap((tier) => {
const group = normalized.filter((candidate) => candidate.tier === tier);
if (!group.length) return [];
const start = rotation % group.length;
return [...group.slice(start), ...group.slice(0, start)];
});
return [...groups, ...normalized.filter((candidate) => !groups.includes(candidate))];
};

const resolveRole = async (handles, role, preferredIndex, rotation) => {
for (const candidate of orderedCandidates(handles, preferredIndex, rotation)) {
const product = await fetchProduct(candidate.handle, role);
if (product) return product;
}
return null;
};

const resolveProducts = async (answers) => {
const plan = plans[answers.style];
const preferredIndex = choices.budget[answers.budget].index;
const rotation = nextRotation(answers);
const expanded = window.coastalRoomFinderRegistryV2?.paths?.[answers.style];
const roleCandidates = expanded ? {
seating: expanded.seating[answers.space], accent: expanded.accent,
cocktail: expanded.cocktail, side: expanded.side,
} : {
seating: plan.products.seating[answers.space], accent: plan.products.accent,
cocktail: plan.products.cocktail, side: plan.products.side,
};
const products = await Promise.all(
Object.entries(roleCandidates).map(([role, handles]) => resolveRole(handles, role, preferredIndex, rotation))
);
return products.filter(Boolean);
};

const money = (cents) => new Intl.NumberFormat('en-US', {
style: 'currency', currency: 'USD', maximumFractionDigits: 2,
}).format(cents / 100);

const finderSummary = (answers, products) => ({
createdAt: new Date().toISOString(),
rotationPolicy: 'controlled-path-rotation-v1',
room: 'Living room',
answers,
labels: Object.fromEntries(Object.entries(answers).map(([key, value]) => [key, choices[key][value].label])),
plan: { key: answers.style, title: plans[answers.style].title },
products: products.map(({ role, handle, title, url, price, variantId }) => ({ role, handle, title, url, price, variantId })),
});

const assessRoomFit = ({ roomLength, roomWidth, doorwayWidth, seatingCapacity, focalPoint, photoPrepared }, answers) => {
const length = Number(roomLength);
const width = Number(roomWidth);
const doorway = Number(doorwayWidth);
const area = length * width;
const notes = [];
const concerns = [];
if (Math.min(length, width) < 10) concerns.push('One room dimension is under 10 ft, so circulation around full-depth seating may be tight.');
if (area < 120 && answers.space !== 'compact') concerns.push('The measured area is smaller than the selected room-size direction. Recheck the Compact path before ordering.');
if (area >= 260 && answers.space === 'compact') notes.push('The room may support a larger seating plan than the Compact path shows.');
if (doorway < 32) concerns.push('The narrowest access point is under 32 in. Verify packaged dimensions, turns, stairs and delivery clearance for every item.');
else notes.push('The reported doorway is at least 32 in, but the complete delivery path still needs to be checked.');
if (Number(seatingCapacity) >= 5 && answers.space === 'compact') concerns.push('The requested seating capacity may be difficult to achieve comfortably with the Compact plan.');
if (focalPoint === 'both') notes.push('Plan sight lines carefully so seating can address both the TV and fireplace without blocking circulation.');
if (focalPoint === 'tv') notes.push('Confirm viewing distance and screen height before fixing the seating position.');
if (focalPoint === 'fireplace') notes.push('Maintain required fireplace clearances and avoid placing upholstery too close to heat.');
if (focalPoint === 'neither') notes.push('A conversation-centered layout can remain flexible; preserve a clear main walking path.');
if (photoPrepared) notes.push('A room photo or sketch was selected locally. It was not uploaded; keep it ready for the designer conversation.');
notes.push('Allow roughly 30–36 in for primary walkways and verify each product’s dimensions on its product page.');
return {
roomLength: length, roomWidth: width, roomArea: Number(area.toFixed(1)), doorwayWidth: doorway,
seatingCapacity: String(seatingCapacity), focalPoint, photoPrepared: Boolean(photoPrepared),
status: concerns.length ? 'review-recommended' : 'promising-start', concerns, notes,
disclaimer: 'Planning guidance only. This does not guarantee product, room or delivery-path fit.',
};
};

const saveForDesigner = (summary) => {
safeStorage.set(sessionStorage, resultStorageKey, JSON.stringify(summary));
emitEvent('room_finder_designer_handoff', { room: summary.room, style: summary.plan.key });
window.location.href = consultationUrl;
};

const renderProduct = (product) => `
<article class="coastal-room-finder-product">
<a class="coastal-room-finder-product__media" href="${product.url}">
${product.image ? `<img src="${product.image}" alt="${product.title.replaceAll('"', '&quot;')}" loading="lazy">` : ''}
</a>
<p class="coastal-room-finder-product__role">${roleLabels[product.role]}</p>
<h3><a href="${product.url}">${product.title}</a></h3>
<p class="coastal-room-finder-product__price">From ${money(product.price)}</p>
</article>
`;

const renderResult = (root, answers, products) => {
const plan = plans[answers.style];
let summary = finderSummary(answers, products);
const total = products.reduce((sum, product) => sum + product.price, 0);
root.innerHTML = `
<section class="coastal-room-finder__stage coastal-room-finder-result" aria-labelledby="coastal-room-finder-result-title">
<div class="coastal-room-finder-result__heading">
<div>
<p class="coastal-room-finder-result__eyebrow">${plan.eyebrow}</p>
<h2 id="coastal-room-finder-result-title">${plan.title}</h2>
</div>
<p class="coastal-room-finder-result__heading-copy">${plan.copy} This is a curated starting point—not a guarantee that every piece fits your room. Confirm measurements and current availability before ordering.</p>
</div>
<ul class="coastal-room-finder-result__summary" aria-label="Your room finder selections">
<li><strong>Space:</strong>${choices.space[answers.space].label}</li>
<li><strong>Lifestyle:</strong>${choices.household[answers.household].label}</li>
<li><strong>Budget:</strong>${choices.budget[answers.budget].label}</li>
<li><strong>Timing:</strong>${choices.timing[answers.timing].label}</li>
</ul>
<div class="coastal-room-finder-result__guidance" aria-label="Guidance for your room">
<p><strong>How to use the room</strong>${choices.household[answers.household].guidance}</p>
<p><strong>Recommended next step</strong>${choices.timing[answers.timing].guidance}</p>
</div>
<div class="coastal-room-finder-result__products">
${products.length ? products.map(renderProduct).join('') : `<p>We could not confirm suitable available products right now. A Coastal designer can still help build the room.</p>`}
</div>
${products.length ? `
<div class="coastal-room-finder-result__total">
<p>This estimate covers the four displayed starting pieces and may be below your overall room budget. Delivery, taxes, options, rugs, lighting and accessories are not included. Product pages remain the final source for price and availability.</p>
<strong>Estimated total ${money(total)}</strong>
</div>
` : ''}
<section class="coastal-room-finder-fit" aria-labelledby="coastal-room-finder-fit-title">
<div class="coastal-room-finder-fit__heading">
<div>
<h3 id="coastal-room-finder-fit-title">Check the room before you order.</h3>
<p>Add a few approximate measurements to reveal likely scale, circulation and delivery-access concerns.</p>
</div>
<button class="coastal-room-finder__button coastal-room-finder__button--secondary" type="button" data-room-finder-fit-toggle aria-expanded="false">Check room fit</button>
</div>
<form class="coastal-room-finder-fit__form" data-room-finder-fit-form hidden>
<div class="coastal-room-finder-fit__field">
<label for="coastal-room-length">Room length (feet)</label>
<input id="coastal-room-length" name="roomLength" type="number" min="6" max="100" step="0.1" inputmode="decimal" required>
</div>
<div class="coastal-room-finder-fit__field">
<label for="coastal-room-width">Room width (feet)</label>
<input id="coastal-room-width" name="roomWidth" type="number" min="6" max="100" step="0.1" inputmode="decimal" required>
</div>
<div class="coastal-room-finder-fit__field">
<label for="coastal-doorway-width">Narrowest doorway or hallway (inches)</label>
<input id="coastal-doorway-width" name="doorwayWidth" type="number" min="20" max="120" step="0.25" inputmode="decimal" required>
</div>
<div class="coastal-room-finder-fit__field">
<label for="coastal-seating-capacity">Preferred seating capacity</label>
<select id="coastal-seating-capacity" name="seatingCapacity" required>
<option value="">Choose one</option><option value="2">2 people</option><option value="3">3 people</option><option value="4">4 people</option><option value="5">5 people</option><option value="6">6 or more people</option>
</select>
</div>
<div class="coastal-room-finder-fit__field">
<label for="coastal-focal-point">Primary focal point</label>
<select id="coastal-focal-point" name="focalPoint" required>
<option value="">Choose one</option><option value="tv">TV</option><option value="fireplace">Fireplace</option><option value="both">TV and fireplace</option><option value="neither">Conversation / no fixed focal point</option>
</select>
</div>
<div class="coastal-room-finder-fit__field">
<label for="coastal-room-photo">Optional room photo or sketch</label>
<input id="coastal-room-photo" name="roomPhoto" type="file" accept="image/*">
</div>
<p class="coastal-room-finder-fit__note coastal-room-finder-fit__field--wide">Your image stays on this device and is not uploaded. Keep it available if you send the plan to a Coastal designer.</p>
<div class="coastal-room-finder-fit__actions">
<button class="coastal-room-finder__button" type="submit">Review my measurements</button>
</div>
<div class="coastal-room-finder-fit__assessment" data-room-finder-fit-assessment hidden aria-live="polite"></div>
</form>
</section>
<div class="coastal-room-finder-result__consult">
<div>
<h3>Want this adapted to your actual room?</h3>
<p>Send the plan with your photos and measurements. Your selected direction and product links will travel with the inquiry.</p>
</div>
<button class="coastal-room-finder__button" type="button" data-room-finder-consult>Send to a designer</button>
</div>
<div class="coastal-room-finder__actions">
<button class="coastal-room-finder__button coastal-room-finder__button--secondary" type="button" data-room-finder-restart>Start over</button>
<div class="coastal-room-finder__actions-group">
<button class="coastal-room-finder__button coastal-room-finder__button--secondary" type="button" data-room-finder-save>Save this plan</button>
<a class="coastal-room-finder__link-button coastal-room-finder__link-button--secondary" href="${plan.searchUrl}">Browse living room</a>
</div>
</div>
<p class="coastal-room-finder__error" hidden data-room-finder-status aria-live="polite"></p>
</section>
`;
const fitToggle = root.querySelector('[data-room-finder-fit-toggle]');
const fitForm = root.querySelector('[data-room-finder-fit-form]');
fitToggle?.addEventListener('click', () => {
const expanded = fitToggle.getAttribute('aria-expanded') === 'true';
fitToggle.setAttribute('aria-expanded', String(!expanded));
fitToggle.textContent = expanded ? 'Check room fit' : 'Hide fit check';
fitForm.hidden = expanded;
if (!expanded) fitForm.querySelector('input')?.focus({ preventScroll: true });
});
fitForm?.addEventListener('submit', (event) => {
event.preventDefault();
if (!fitForm.reportValidity()) return;
const data = new FormData(fitForm);
const fitCheck = assessRoomFit({
roomLength: data.get('roomLength'), roomWidth: data.get('roomWidth'), doorwayWidth: data.get('doorwayWidth'),
seatingCapacity: data.get('seatingCapacity'), focalPoint: data.get('focalPoint'),
photoPrepared: Boolean(fitForm.elements.roomPhoto?.files?.length),
}, answers);
summary = { ...summary, fitCheck };
const assessment = fitForm.querySelector('[data-room-finder-fit-assessment]');
assessment.hidden = false;
assessment.innerHTML = `
<h4>${fitCheck.concerns.length ? 'A designer review is recommended.' : 'These measurements are a promising starting point.'}</h4>
<ul>${[...fitCheck.concerns, ...fitCheck.notes].map((note) => `<li>${note}</li>`).join('')}</ul>
<p class="coastal-room-finder-fit__note">${fitCheck.disclaimer}</p>
`;
emitEvent('room_finder_fit_check', { status: fitCheck.status, concern_count: fitCheck.concerns.length });
});
root.querySelector('[data-room-finder-consult]')?.addEventListener('click', () => saveForDesigner(summary));
root.querySelector('[data-room-finder-restart]')?.addEventListener('click', () => {
emitEvent('room_finder_restart', { from: 'result' });
mountFinder(root.closest('.coastal-room-finder'), true);
});
root.querySelector('[data-room-finder-save]')?.addEventListener('click', (event) => {
const saved = safeStorage.set(localStorage, savedPlanStorageKey, JSON.stringify(summary));
const status = root.querySelector('[data-room-finder-status]');
event.currentTarget.textContent = saved ? 'Plan saved on this device' : 'Could not save on this device';
if (status) {
status.hidden = false;
status.textContent = saved ? 'Your room direction has been saved on this device.' : 'Your browser prevented this plan from being saved.';
}
emitEvent('room_finder_plan_save', { room: summary.room, style: summary.plan.key, saved });
});
emitEvent('room_finder_result_view', { room: summary.room, style: summary.plan.key, product_count: products.length });
};

const renderStep = (root, state) => {
const step = steps[state.index];
const options = choices[step.key];
const progress = ((state.index + 1) / steps.length) * 100;
root.innerHTML = `
<div class="coastal-room-finder__header">
<div>
<p class="coastal-room-finder__eyebrow">Living Room Finder</p>
<h1>Build a room that feels like you.</h1>
<p class="coastal-room-finder__intro">Five quick questions will create a coordinated starting point from current Coastal products.</p>
</div>
<div class="coastal-room-finder__progress-wrap">
<div class="coastal-room-finder__progress-label"><span>Question ${state.index + 1} of ${steps.length}</span><span>${Math.round(progress)}%</span></div>
<div class="coastal-room-finder__progress" role="progressbar" aria-label="Room finder progress" aria-valuemin="0" aria-valuemax="100" aria-valuenow="${Math.round(progress)}"><span style="width:${progress}%"></span></div>
</div>
</div>
<section class="coastal-room-finder__stage" aria-labelledby="coastal-room-finder-step-title">
<p class="coastal-room-finder__eyebrow">${step.eyebrow}</p>
<h2 id="coastal-room-finder-step-title">${step.title}</h2>
<fieldset class="coastal-room-finder__options">
<legend class="sr-only">${step.title}</legend>
${Object.entries(options).map(([value, option]) => `
<label class="coastal-room-finder__option">
<input type="radio" name="coastal-room-finder-${step.key}" value="${value}" ${state.answers[step.key] === value ? 'checked' : ''}>
<strong>${option.label}</strong>
<span>${option.copy}</span>
</label>
`).join('')}
</fieldset>
<p class="coastal-room-finder__error" hidden data-room-finder-error role="alert">Choose one option to continue.</p>
<div class="coastal-room-finder__actions">
${state.index > 0 ? '<button class="coastal-room-finder__button coastal-room-finder__button--secondary" type="button" data-room-finder-back>Back</button>' : '<span></span>'}
<button class="coastal-room-finder__button" type="button" data-room-finder-next>${state.index === steps.length - 1 ? 'Build my room direction' : 'Continue'}</button>
</div>
</section>
`;
root.querySelector('[data-room-finder-back]')?.addEventListener('click', () => {
state.index -= 1;
renderStep(root, state);
});
root.querySelector('[data-room-finder-next]')?.addEventListener('click', async (event) => {
const selected = root.querySelector(`input[name="coastal-room-finder-${step.key}"]:checked`);
const error = root.querySelector('[data-room-finder-error]');
if (!selected) {
if (error) error.hidden = false;
return;
}
state.answers[step.key] = selected.value;
emitEvent('room_finder_step_complete', { step: step.key, step_number: state.index + 1 });
if (state.index < steps.length - 1) {
state.index += 1;
renderStep(root, state);
root.querySelector('input')?.focus({ preventScroll: true });
root.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
return;
}
event.currentTarget.disabled = true;
root.innerHTML = '<div class="coastal-room-finder__stage coastal-room-finder__loading" role="status"><strong>Building your room direction…</strong><p>Checking the recommended pieces against current storefront availability.</p></div>';
const products = await resolveProducts(state.answers);
renderResult(root, state.answers, products);
root.scrollIntoView({ behavior: 'auto', block: 'start' });
});
};

const mountFinder = (existingRoot, reset = false) => {
if (window.location.pathname !== '/pages/design-help') return;
const params = new URLSearchParams(window.location.search);
if (params.get('finder') !== 'living-room') return;
const main = document.querySelector('main');
if (!main) return;
const root = existingRoot || main.querySelector('.coastal-room-finder') || document.createElement('div');
if (!existingRoot && !root.isConnected) {
root.className = 'coastal-room-finder';
root.dataset.coastalRoomFinder = 'living-room';
main.prepend(root);
[...main.children].forEach((child) => {
if (child !== root && !child.closest?.('.coastal-room-finder')) child.hidden = true;
});
}
const initialAnswers = reset ? {} : {};
renderStep(root, { index: 0, answers: initialAnswers });
emitEvent('room_finder_start', { room: 'Living room' });
};

const enhanceConsultationHandoff = () => {
if (window.location.pathname !== '/pages/contact') return;
const params = new URLSearchParams(window.location.search);
if (params.get('from') !== 'room-finder') return;
const raw = safeStorage.get(sessionStorage, resultStorageKey);
if (!raw) return;
let summary;
try { summary = JSON.parse(raw); } catch { return; }
const form = document.querySelector('main form[action*="/contact"]:has(textarea)');
if (!form || form.querySelector('[data-coastal-room-finder-context]')) return;
const fit = summary.fitCheck || {};
const roomName = String(summary.room || 'Room').trim();
const roomFinderName = `${roomName} Finder`;
const accessWidth = fit.accessWidth ?? fit.doorwayWidth;
const answerLabel = (key) => summary.labels?.[key] || summary.answers?.[key] || '';
const productUrl = (product) => String(product.url || '').startsWith('http')
? product.url
: `${window.location.origin}${product.url || ''}`;
const priority = fit.priorityLabel || fit.seatingCapacity || '';
const values = {
'Room finder room': roomName,
'Room finder result': summary.plan?.title,
'Room finder style': answerLabel('style'),
'Room finder space': answerLabel('space'),
'Room finder lifestyle': answerLabel('household'),
'Room finder budget': answerLabel('budget'),
'Room finder timing': answerLabel('timing'),
'Room finder products': (summary.products || []).map((product) => `${product.title}: ${productUrl(product)}`).join('\n'),
'Room measurements': fit.roomLength && fit.roomWidth ? `${fit.roomLength} ft × ${fit.roomWidth} ft${fit.roomArea ? ` (${fit.roomArea} sq ft)` : ''}` : '',
'Narrowest access point': accessWidth ? `${accessWidth} in` : '',
'Planning priority': priority,
'Room focal point': fit.focalPoint,
'Fit check status': fit.status,
'Fit check concerns': (fit.concerns || []).join('\n'),
'Fit check notes': (fit.notes || []).join('\n'),
'Fit check disclaimer': fit.disclaimer,
};
Object.entries(values).forEach(([name, value]) => {
if (!value) return;
const input = document.createElement('input');
input.type = 'hidden';
input.name = `contact[${name}]`;
input.value = value;
input.defaultValue = value;
input.setAttribute('value', value);
input.dataset.coastalRoomFinderContext = name;
form.appendChild(input);
});
const message = form.querySelector('textarea');
if (message && !message.value.trim()) {
const measurementLine = fit.roomLength && fit.roomWidth
? `My ${roomName.toLowerCase()} is approximately ${fit.roomLength} ft × ${fit.roomWidth} ft${accessWidth ? `, with a ${accessWidth} in narrowest access point` : ''}.`
: 'I will add my measurements below.';
const priorityLine = priority ? `\nMy planning priority is: ${priority}.` : '';
const concernLine = fit.concerns?.length ? `\nThe fit check flagged ${fit.concerns.length} item${fit.concerns.length === 1 ? '' : 's'} for designer review.` : '';
const photoLine = fit.photoPrepared ? '\nI also have a room photo or sketch ready to share.' : '';
message.value = `I used the ${roomFinderName} and would like help adapting the ${summary.plan?.title || 'recommended direction'} to my room.\n\n${measurementLine}${priorityLine}${concernLine}${photoLine}\n\nMy questions and product preferences:`;
}
const dimensionsInput = form.querySelector('#coastal-design-dimensions');
if (dimensionsInput && fit.roomLength && fit.roomWidth && !dimensionsInput.value) dimensionsInput.value = `${fit.roomLength} ft × ${fit.roomWidth} ft`;
const roomTypeInput = form.querySelector('#coastal-design-room-type');
if (roomTypeInput && !roomTypeInput.value) {
const matchingOption = [...roomTypeInput.options].find((option) => option.textContent.trim().toLowerCase() === roomName.toLowerCase());
if (matchingOption) roomTypeInput.value = matchingOption.value;
}
const productsInput = form.querySelector('#coastal-design-products');
if (productsInput && !productsInput.value) productsInput.value = (summary.products || []).map((product) => product.title).join(', ');
safeStorage.set(sessionStorage, resultStorageKey, JSON.stringify({ ...summary, handedOffAt: new Date().toISOString() }));
};

const connect = () => {
ensureStyles();
mountLaunchCard();
mountFinder();
enhanceConsultationHandoff();
};

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', connect, { once: true });
else connect();
document.addEventListener('shopify:section:load', connect);
})();

/* coastal-experience-suite-loader-v1 */
(() => {
if (window.coastalExperienceSuiteLoaderV1) return;
window.coastalExperienceSuiteLoaderV1 = true;
const current = document.currentScript?.src;
if (!current) return;
const script = document.createElement('script');
const suiteUrl = new URL('coastal-experience-suite-v1.js', current);
suiteUrl.search = new URL(current).search;
suiteUrl.searchParams.set('coastal_suite_revision', '20260908-multi-room-fit-v1');
script.src = suiteUrl.href;
script.defer = true;
document.head.appendChild(script);
})();
